import { render, staticRenderFns } from "./booking-table-input.vue?vue&type=template&id=222c6050&scoped=true&"
import script from "./booking-table-input.ts?vue&type=script&lang=ts&"
export * from "./booking-table-input.ts?vue&type=script&lang=ts&"
import style0 from "./booking-table-input.scss?vue&type=style&index=0&id=222c6050&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222c6050",
  null
  
)

export default component.exports